export const applyCheckoutUploadTokens = (
  passengers = [],
  uploadEntries = [],
  uploadTokens = []
) => {
  const tokenByFileKey = new Map(
    uploadEntries.map((entry, index) => [entry.fileKey, uploadTokens[index]])
  );

  return passengers.map((passenger) =>
    passenger.map((field) => {
      if (!Array.isArray(field?.files) || field.files.length === 0) {
        return field;
      }

      const checkoutUploadTokens = field.files
        .map(({ fileKey }) => tokenByFileKey.get(fileKey))
        .filter(Boolean);
      const fieldWithoutFiles = { ...field };
      delete fieldWithoutFiles.files;

      return {
        ...fieldWithoutFiles,
        checkoutUploadTokens
      };
    })
  );
};

export const stageCheckoutPassengerUploads = async ({
  tripId,
  passengers,
  uploadEntries,
  uploadFile
}) => {
  if (!uploadEntries.length) {
    return { passengers, failedUploads: [] };
  }

  const uploadTokens = [];
  const failedUploads = [];

  for (const entry of uploadEntries) {
    try {
      const response = await uploadFile({
        tripId,
        tripPassengerFieldId: entry.tripPassengerFieldId,
        clientPassengerKey: entry.clientPassengerKey,
        file: entry.file
      });
      const uploadToken = response?.data?.uploadToken;

      if (!uploadToken) {
        throw new Error('Passenger file upload did not return a token.');
      }

      uploadTokens.push(uploadToken);
    } catch (error) {
      uploadTokens.push(null);
      failedUploads.push({ fileKey: entry.fileKey, error });
    }
  }

  return {
    passengers: applyCheckoutUploadTokens(
      passengers,
      uploadEntries,
      uploadTokens
    ),
    failedUploads
  };
};
